import { ICellRendererParams, BodyScrollEvent } from 'ag-grid-community';
import { FC, useEffect, useState } from 'react';
import { MiddleEllipsisWhisper } from '@aleph/shared-components';

const DefaultRedditReportsCellRenderer: FC<ICellRendererParams> = (params) => {
	const [top, setTop] = useState(0);

	useEffect(() => {
		if (!params.api) {
			return () => {};
		}

		const onBodyScroll = (e: BodyScrollEvent) => {
			setTop(e.top);
		};

		params.api.addEventListener('bodyScroll', onBodyScroll);

		return () => {
			params.api.removeEventListener('bodyScroll', onBodyScroll);
		};
	}, [params.api]);

	const rowBottom = (params.node.rowTop ?? 0) - 20;

	if (top > rowBottom) {
		return (
			<div
				className="px-[8px] !block"
			>
				<MiddleEllipsisWhisper value={params.value} />
			</div>
		);
	}

	return (
		<div
			className="px-[8px] report-cell"
		>
			<MiddleEllipsisWhisper value={params.value} />
		</div>
	);
};

export default DefaultRedditReportsCellRenderer;
